import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { InputGroup } from "react-bootstrap";
import { FormControl } from "react-bootstrap";

import Icons from "../../../../components/icon";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import Icon from "../../../icon";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DEFAULT_PAGE_VALUE, MAX_LENGTH } from "../../../../constants/external-constants";

class DetailsInfo extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.resetDefault=this.resetDefault.bind(this);
    this.state={
      show:false,
      clearData:false,
      searchVal: "",
      selected:[],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
      selectedTwo:[]
    }
  }

  handleClose() {
    const {setSearchValue } = this.props
    this.setState({ show: false, searchVal: "" });
    if (typeof setSearchValue === "function") {
        setSearchValue("");
    }
  }

  handleShow() {    
      const { setSearchValue } = this.props
      this.setState({ searchVal: "" });
      if (typeof setSearchValue === "function") {
          setSearchValue("");
      }
    this.fetchData()
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };

  resetDefault() {   
    this.setState({clearData:true});
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    const {valueselected, getAccountDetail} = this.props;
    if (typeof getAccountDetail === 'function') {
        getAccountDetail(valueselected);
    }
  }

  resetClearData(item) {
    this.setState({clearData:item})
  }

  handleSearchChange  = (e) => {
    this.setState({ searchVal: e.target.value });
  }
  
  toLocaleLanguage = (key) => {
    const { locale } = this.props;
    if (locale === null || locale === '' || locale === undefined)
        return translation[translation['defaultLocaleLanguage']][key];

    return translation[locale][key];
  }

  searchAction = async (e) => {
      const { setSearchValue, valueselected, getAccountLinked } = this.props;
    let searchVal = e.target.value;
    if (typeof setSearchValue === 'function') {
         setSearchValue(searchVal);
    }
    if (e.key === 'Enter' || e.type === 'blur'){
        if (typeof getAccountLinked === 'function') {
            await getAccountLinked(valueselected, searchVal);
        }
      e.preventDefault();
    } 
}

handlePaginationAction = (pageIndex)=>{
    const {valueselected} = this.props;
    this.props.getAccountLinked(valueselected, this.state.searchVal, pageIndex)
}

navigateToDetails(rowItem) {
    if (rowItem != null) {      
       window.open(`${this.props.routeLocation}/${rowItem.ID}`, "_blank")
    }
}

  render(){
    const {show }=this.state;
    const { detailsInfo, linkedTitle } = this.props;
    return(
      <>

        <Icon
            name="circle-info-reg"
            size="18px"
            customClassName="icon-nav"            
            containerClass="info-container"
            onClick={this.handleShow.bind(this)}
        />
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-dialog-container none-scroll"
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <div className="inventory-detail-info-container data-table">
              <div className="detail-info-wrapper">
                 <table className="detail-main-table detail-info-table">
                   <tbody>
                      <tr>
                          <td>{this.toLocaleLanguage('account_number_capital')}</td>
                          <td>{detailsInfo?.accountNumber && detailsInfo.accountNumber}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('account_type_capital')}</td>
                          <td>{detailsInfo?.accountType && detailsInfo.accountType}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('contract_id_capital')}</td>
                          <td>{detailsInfo?.contractID && detailsInfo.contractID}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('vendor_capital')}</td>
                          <td>{detailsInfo?.vendor && detailsInfo.vendor}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('currency_capital')}</td>
                          <td>{detailsInfo?.currency && detailsInfo.currency}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('service_type_capital')}</td>
                          <td>{detailsInfo?.serviceType && detailsInfo.serviceType}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('status_capital')}</td>
                          <td>{detailsInfo?.status && detailsInfo.status}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('client_capital')}</td>
                          <td>{detailsInfo?.client && detailsInfo.client}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('allocation_level_capital')}</td>
                          <td>{detailsInfo?.allocationLevel && detailsInfo.allocationLevel}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('ap_vendor_id_capital')}</td>
                          <td>{detailsInfo?.apVendorID && detailsInfo.apVendorID}</td>
                        </tr>
                        <tr>
                          <td>{this.toLocaleLanguage('remit_id_capital')}</td>
                          <td>{detailsInfo?.remitID && detailsInfo.remitID}</td>
                        </tr>
                   </tbody>
                 </table>
                 <h1>{this.toLocaleLanguage('location_capital')}</h1>
                 <table className="detail-main-table detail-info-table">
                    <tbody>
                      <tr>
                        <td>{this.toLocaleLanguage('billing_address_capital')}</td>
                         <td>{detailsInfo?.billingAddress && detailsInfo.billingAddress}</td>
                      </tr>
                      <tr>
                        <td>{this.toLocaleLanguage('remit_address_capital')}</td>
                        <td>{detailsInfo?.remitAddress && detailsInfo.remitAddress}</td>
                      </tr>
                    </tbody>
                 </table>
                 <h1>{this.toLocaleLanguage('cost_allocation_capital')}</h1>
                   <TablePagination 
                        classNameWrapper="table-container"
                        columns={this.props.Headers != undefined ? this.props.Headers : []} 
                        pageList={this.props.costAlloData != undefined ? this.props.costAlloData : []}                         
                        isDataLoaded={true}  
                        showSearchBox={false} 
                        paginationHidden={true}
                        isNotSortable={true}                      
                  /> 
                
              </div>
              <div className="vertical-separator"></div>
              <div className="detail-info-wrapper circuit-info-wrapper">
                  <div className="linked-circuit-container">
                    <h1>{this.toLocaleLanguage(this.props.linkedTitle)}</h1>
                    <span>{this.props.linkedPages ? this.props.linkedPages.TotalEntries : 0} {linkedTitle == "linked_circuits_capital" ? this.toLocaleLanguage('total_circuits') : this.toLocaleLanguage('total_invoices')}</span>
                  </div>
                  <div className="linked-circuit-search">
                    <InputGroup size="sm" className="request-input-header">
                        <InputGroup.Text id="inputGroup-sizing-sm">
                              <Icons name="search" customClassName="icon-search" size="12px" />
                        </InputGroup.Text>
                        <FormControl
                                value={this.state.searchVal}
                                onChange={(e) => this.handleSearchChange(e)}
                                onBlur={this.searchAction}
                                onKeyPress={this.searchAction}
                                placeholder={this.props.searchPlaceHolder}
                                aria-label="Small"
                                aria-describedby="inputGroup-sizing-sm"
                                maxLength={MAX_LENGTH.limit_100}
                        />
                    </InputGroup>
                  </div>
                
                  <TablePagination 
                                key="table-pagination-key"
                                columns={this.props.linkedHeaders != undefined ? this.props.linkedHeaders : []}
                                pageList={this.props.linkedData != undefined ? this.props.linkedData.Items : []}
                                pages={this.props.linkedPages ? this.props.linkedPages : DEFAULT_PAGE_VALUE}
                                rowClickAction={(rowItem) => this.navigateToDetails(rowItem)}
                                modalPagination={true}
                                paginationAction={this.handlePaginationAction}
                                totalPage={this.props.linkedPages ? this.props.linkedPages.TotalEntries : 0}
                                isNotSortable={true}
                                haveLink={true}
                                tableClassName="table-fit custom-table-header linked-circuit-modal-table-body"
                                noDataAvailable={true}
                  /> 
              </div>
           </div>
        </Modal.Body>        
      </Modal>

      </>
    );
  }
}

export default DetailsInfo;